import { Expose, Transform } from "class-transformer";
import { IsDefined, IsNotEmpty, IsString } from "class-validator";

import { CDBaseEntity, CDColumn } from "../orm";

export class LocalizedField extends CDBaseEntity {
  @CDColumn()
  @IsString()
  @IsDefined()
  @IsNotEmpty({ message: "English translations shouldn't be empty" })
  @Transform((value) => value || "")
  @Expose()
  public en: string = "";

  @CDColumn()
  @IsString()
  @Transform((value) => value || "")
  @Expose()
  public de: string = "";

  @CDColumn()
  @IsString()
  @Transform((value) => value || "")
  @Expose()
  public es: string = "";

  @CDColumn()
  @IsString()
  @Transform((value) => value || "")
  @Expose()
  public pt: string = "";

  @CDColumn()
  @IsString()
  @Transform((value) => value || "")
  @Expose()
  public cs: string = "";

  @CDColumn()
  @IsString()
  @Transform((value) => value || "")
  @Expose()
  public ru: string = "";

  @CDColumn()
  @IsString()
  @Transform((value) => value || "")
  @Expose()
  public zh: string = "";

  @CDColumn()
  @IsString()
  @Transform((value) => value || "")
  @Expose()
  public ko: string = "";

  @CDColumn()
  @IsString()
  @Transform((value) => value || "")
  @Expose()
  public fr: string = "";
}
